<!--
 * @Author: Victor victorqwer1234567890@gmail.com
 * @Date: 2023-12-27 18:27:55
 * @LastEditors: Merlin
 * @LastEditTime: 2024-12-02 17:59:13
-->
<template>
    <Modal
        v-bind="$attrs"
        :model-value="modelValue"
        :container-class="`modalHeader ${containerClass} ${slots.footer ? '!p-0' : ''}`"
        v-if="modelValue"
        @click.self="() => onBackdrop()"
        class="w-full"
    >
        <!-- Header -->
        <div
            v-if="slots.header"
            :class="[slots.footer ? 'p-3' : 'p-0']"
            class="!z-20 py-[20px] px-[24px] text-2xl relative items-center text-white font-bold flex justify-between"
        >
            <slot name="header"></slot>
            <QIcon
                v-if="showCloseIcon"
                name="close"
                class="text-[#93acd3] cursor-pointer"
                @click="close"
            />
        </div>
        <div
            v-else
            class="text-3xl py-[20px] px-[24px] font-bold !z-20 relative text-white"
            :class="[slots.footer ? 'p-3' : 'p-0']"
        >
            <span class="text-[32px]">{{ title }}</span>
            <QIcon
                name="close"
                class="absolute text-[#93acd3] right-[15px] top-[15px] cursor-pointer"
                @click="close"
            />
        </div>

        <!-- Body -->
        <div class="px-[24px] pb-[20px]"
            :style="bodyStyle"
        >
            <slot class="relative"></slot>
        </div>

        <!-- Footer -->
        <div
            v-if="slots.footer"
            :class="footerClass"
            class="flex left-0 right-0 rounded-b-2xl bg-[#161F2CFF] py-[16px] px-[24px] gap-[8px]"
        >
            <slot name="footer"></slot>
        </div>
    </Modal>
</template>


<script lang="ts" setup>
const props = defineProps({
    modelValue: {
        type: Boolean,
        required: true,
    },
    backdrop: {
        type: Boolean,
        default: true,
    },
    showCloseIcon: {
        type: Boolean,
        default: true,
    },
    title: {
        type: String,
        default: '',
    },
    containerClass: {
        type: String,
        default: '',
    },
    bodyStyle: {
        type: Object,
    },
    footerClass: {
        type: String,
        default: '',
    },
});
const slots = useSlots();
const { modelValue: toRefModelValue } = toRefs(props);

const emit = defineEmits(['update:modelValue','hideModel']);
const close = () => {
    emit('hideModel')
    emit('update:modelValue', false);
};
const onBackdrop = () => {
    if (props.backdrop) {
        close();
    }
};

const fnOverflowManager = (isVisible)=>{
    isVisible ??= props.modelValue;
    const sNewValue = isVisible ? 'hidden' : 'auto'; 
    document.body.style.overflow = sNewValue;
};

watch(
    () => props.modelValue,
    fnOverflowManager,
);

onBeforeUnmount(()=>{
    fnOverflowManager(false);
});

</script>

<style>
.modalHeader::before {
    background: linear-gradient(180deg, #003370, transparent);
    border-radius: 14px 14px 0 0;
    content: '';
    display: block;
    height: 72px;
    left: 0;
    pointer-events: none;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 0;
}
</style>

